module.exports = __webpack_public_path__ + "img/deposit5.41a122bd.jpg";